export default __webpack_public_path__ + "static/media/card.41a92890.jpg";